
<script>
import BarList from '../components/bar-list'
import { apiORDSdelete } from '../shared/api-functions'
import { SysVars } from '../main';
import PdstatusForm from './pdstatus-form'

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            pdstatus: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            currentStatus: {},
            codstatus: null,
        }
    },

    computed: {
        pdstatusList: function () {
            return this.$store.getters.getPdstatusList
        },
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    methods: {
        handleEdit (status) {
            //abre a tela de edicao
            this.currentStatus = status
            this.crud = SysVars.crudU;
            this.$set(status, 'show', true)
        },

        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.showForm = true
        },

        closeForm() {
            this.currentStatus.show = false
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codstatus":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadPdstatus', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        },

        handleDelete (pdstatus) {
            //BOTAO Excluir
            this.apiDelete(pdstatus)
        },

        async apiDelete (pdstatus) {
            //efetua a exclusao
            var modulo = 'cg/pdstatus/' + pdstatus.codstatus
            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },


    },

    components: {
        BarList, PdstatusForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list">
            <bar-list
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="false"
                single-entity="Status de Pedido"
                plural-entity="Status de Pedido"
                @search="search"
                @new="handleNew"
                @refresh="loadData">
            </bar-list>
            <br>
            <div class="default-container nb-card-list">
                <alert v-if="pdstatusList.length == 0" type="norecord"></alert>

                <div class="nb-card-inline-form mb-3" v-if="showForm">
                    <pdstatus-form :index="codstatus" :crud="crud" @closeform="closeForm"></pdstatus-form>
                </div>

                <article class="nb-card" v-for="pdstatus in pdstatusList" :key="pdstatus.codstatus">
                    <div class="nb-card-top" v-show="!pdstatus.show">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ pdstatus.descricao }}</h2>
                                    <span v-if="pdstatus.codstatus <= 13" class="nb-card-badge nb-card-badge--neutral">
                                        Padrão
                                    </span>
                                    <span v-else class="nb-card-badge nb-card-badge--success">
                                        Personalizado
                                    </span>
                                </div>
                                <div class="nb-card-code" v-if="pdstatus.codstatus">
                                    Código <strong>{{ pdstatus.codstatus }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid
                                :options="{barDefault: true, btnDelete: (pdstatus.codstatus>13), btnEdit: (pdstatus.codstatus>13), btnEditLabel: 'Editar'}"
                                :moreActions="[]"
                                @edit="handleEdit(pdstatus)"
                                @view="handleEdit(pdstatus, true)"
                                @delete="handleDelete(pdstatus)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-inline-form" v-if="pdstatus.show">
                        <pdstatus-form :index="pdstatus.codstatus" :crud="crud" @closeform="closeForm"></pdstatus-form>
                    </div>
                </article>

            </div>
        </div>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--success {
  color: #166534;
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.nb-card-badge--neutral {
  color: #475569;
  background: #f1f5f9;
  border-color: #e2e8f0;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-inline-form {
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/pdstatus-list.vue